import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import PlayerInfoTabs from './PlayerInfoTabs';
import type { PlayerInfoTabsProps, PlayerInfoTabsAPI, PlayerInfoTabsHandle } from './types';

declare global {
  interface Window {
    mountPlayerInfoTabs: (containerId: string, props: PlayerInfoTabsProps) => PlayerInfoTabsHandle;
  }
}

window.mountPlayerInfoTabs = function mountPlayerInfoTabs(
  containerId: string,
  props: PlayerInfoTabsProps,
): PlayerInfoTabsHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('PlayerInfoTabs: container not found:', containerId);
    return { unmount: () => {}, get api() { return null; } };
  }

  const apiRef = createRef<PlayerInfoTabsAPI>();
  const root = createRoot(container);
  root.render(React.createElement(PlayerInfoTabs, { ...props, ref: apiRef }));

  return {
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};
